import { Box, Stack, Typography, Divider } from '@mui/material';
import {
  DefaultOutlinedButton,
  DefaultContainedButton,
  DefaultContainedLoadingButton,
  RedOutlinedLoadingButton,
} from '../../Buttons';

export default function DocumentUploadCardSection({
  label,
  file,
  setFile,
  uploading,
  deleting,
  canEdit,
  fileRef,
  fileUrl,
  fileSize,
  onUpload,
  onDelete,
}) {
  const cdnUrl = (url) => {
    const newUrl = url?.replace(
      'https://media-upload-gest.s3.eu-south-1.amazonaws.com',
      'https://d1b25gkgy8638z.cloudfront.net'
    );
    return newUrl;
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {label}
      </Typography>

      {fileUrl ? (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
        >
          <Stack direction="row" spacing={2}>
            <a href={cdnUrl(fileUrl)} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <DefaultOutlinedButton>Visualizza</DefaultOutlinedButton>
            </a>

            <DefaultContainedButton onClick={() => navigator.clipboard.writeText(cdnUrl(fileUrl))}>
              Copia Link
            </DefaultContainedButton>
          </Stack>

          {canEdit && (
            <RedOutlinedLoadingButton loading={deleting} onClick={onDelete}>
              Rimuovi
            </RedOutlinedLoadingButton>
          )}
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            {label === 'Locandina' ? 'Nessuna' : 'Nessun'} {label.toLowerCase()}{' '}
            {label === 'Locandina' ? 'caricata' : 'caricato'}.
          </Typography>

          <input
            type="file"
            ref={fileRef}
            accept={label === 'Locandina' ? '.jpg,.jpeg,.png' : '.pdf,.jpg,.jpeg,.png'}
            style={{ display: 'none' }}
            onChange={(e) => setFile(e.target.files[0])}
          />

          {canEdit && (
            <Box>
              <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                <DefaultOutlinedButton disabled={uploading} onClick={() => fileRef.current?.click()}>
                  Seleziona File
                </DefaultOutlinedButton>

                <DefaultContainedLoadingButton onClick={onUpload} loading={uploading} disabled={uploading || !file}>
                  Carica
                </DefaultContainedLoadingButton>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                La dimensione massima consentita è di {fileSize}.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                File consentiti: {label === 'Locandina' ? 'JPG, JPEG, PNG' : 'PDF, JPG, JPEG, PNG'}.
              </Typography>
            </Box>
          )}

          {file && (
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
              File selezionato: {file.name}
            </Typography>
          )}
        </Stack>
      )}
    </Box>
  );
}
